import { Calendar, Folder } from "lucide-react";
import { CreateReportingPeriod } from "../../CreateReportingPeriodDialog/CreateReportingPeriod";

interface EmptyStateProps {
  noFundSelected?: boolean;
  onCreatePeriod?: (values: { period: Date; isOpen: boolean }) => Promise<void>;
}

export function EmptyState({
  noFundSelected = false,
  onCreatePeriod,
}: EmptyStateProps) {
  if (noFundSelected) {
    return (
      <div className="w-full border-b border-border bg-background/95 backdrop-blur-sm">
        <div className="flex items-center justify-center px-3 py-8">
          <div className="flex items-center gap-3 text-muted-foreground">
            <div className="p-2 rounded-full bg-muted/50">
              <Folder className="h-5 w-5" />
            </div>
            <div className="text-center">
              <p className="text-sm font-medium">No Fund Selected</p>
              <p className="text-xs text-muted-foreground/80">
                Select a fund to view reporting periods
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full border-b border-border bg-background/95 backdrop-blur-sm">
      <div className="flex items-center justify-between px-3 py-2">
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium">Reporting Timeline</span>
        </div>
        {onCreatePeriod && <CreateReportingPeriod onSubmit={onCreatePeriod} />}
      </div>
      <div className="flex items-center justify-center px-3 py-8">
        <div className="flex items-center gap-3 text-muted-foreground">
          <div className="p-2 rounded-full bg-muted/50">
            <Calendar className="h-5 w-5" />
          </div>
          <div className="text-center">
            <p className="text-sm font-medium">No Reporting Periods</p>
            <p className="text-xs text-muted-foreground/80">
              Create your first reporting period to get started
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
